export const dataComprovantesReducer = (state, action) => {
  const attachments = {
    attachments: action.payload?.attachments,
    idPedido: action.payload?.idPedido,
  };
  state.dataComprovantes.data = action.payload?.idPedido ? [attachments] : [];
  state.dataComprovantes.isLoading = false;
};
